"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _multipassCustomerRoute["default"];
  }
});

var _multipassCustomerRoute = _interopRequireDefault(require("./multipass-customer-route"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }